// extracted by mini-css-extract-plugin
export var activeFilterButton = "_ru-c";
export var backButton = "_ru-4";
export var backIcon = "_ru-5";
export var chevronShortcut = "_ru-6";
export var container = "_ru-1";
export var editor = "_ru-8";
export var editorWrapper = "_ru-7";
export var prefix = "_ru-2";
export var searchIcon = "_ru-3";
export var suffix = "_ru-9";
export var suffixContent = "_ru-a";
export var suffixText = "_ru-b";
export var wrapper = "_ru-0";